import React, { useEffect, useMemo } from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
import Konva from 'konva';
// Component for each product image
const StaticImage = ({ imageData, canvasScaler, imageRef, blackWhiteEffect }) => {
    const [canvasImage] = useImage(imageData.uploadedImage, 'anonymous');
    const cachedImage = useMemo(() => canvasImage, [canvasImage]);
    // Apply grayscale filter when blackWhiteEffect changes
    useEffect(() => {
        var _a;
        if (imageRef.current && cachedImage) {
            if (blackWhiteEffect) {
                imageRef.current.filters([Konva.Filters.Grayscale]);
                imageRef.current.cache();
            }
            else {
                imageRef.current.filters([]);
                imageRef.current.cache();
            }
            (_a = imageRef.current.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
        }
    }, [blackWhiteEffect, cachedImage]);
    if (imageData.uploadedImage == null) {
        return null;
    }
    return (React.createElement(Image, { ref: imageRef, width: imageData.position.width * canvasScaler, height: imageData.position.height * canvasScaler, x: imageData.position.pos_x * canvasScaler, y: imageData.position.pos_y * canvasScaler, rotation: imageData.position.rotation, offsetY: (imageData.position.height * canvasScaler) / 2, offsetX: (imageData.position.width * canvasScaler) / 2, image: cachedImage, fill: "transparent" }));
};
export default StaticImage;
